export const successAlertDuration = 2000;